import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Fleet from "@/pages/Fleet";
import Contact from "@/pages/Contact";
import Careers from "@/pages/Careers";

function App() {
    return (
        <div className="App min-h-screen bg-[#040914] text-white font-sans">
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <main data-testid="main-content">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/fleet" element={<Fleet />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/careers" element={<Careers />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
                <FloatingActions />
                <Toaster
                    theme="dark"
                    position="top-right"
                    toastOptions={{
                        style: {
                            background: "#0B1324",
                            border: "1px solid rgba(255,255,255,0.1)",
                            color: "#fff",
                            borderRadius: 0,
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
